import angular from 'angular';
import { GetStartedInfoConfig } from './info.config';
import { GetStartedInfoComponent } from './info.component';
import form from '../get-started-form';
import { SuffixSelectModule } from '../../common/directives';

export const GetStartedInfoModule = angular
  .module('app.get-started.info', [form.name, SuffixSelectModule.name])
  .config(GetStartedInfoConfig)
  .component('updGetStartedInfo', GetStartedInfoComponent);
